import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';

function AdminDashboard() {
  const [stats, setStats] = useState({
    products: 0,
    orders: 0,
    users: 0,
    discounts: 0
  });

  // Load quick stats for the dashboard cards
  useEffect(() => {
    async function loadStats() {
      try {
        const [products, orders, users, discounts] = await Promise.all([
          getDocs(collection(db, 'products')),
          getDocs(collection(db, 'orders')),
          getDocs(collection(db, 'users')),
          getDocs(collection(db, 'discounts'))
        ]);
        setStats({
          products: products.size,
          orders: orders.size,
          users: users.size,
          discounts: discounts.size
        });
      } catch (err) {
        console.error('Error loading dashboard stats:', err);
      }
    }
    loadStats();
  }, []);

  const cards = [
    {
      icon: '📦',
      label: 'Products',
      count: stats.products,
      description: 'Add, edit, or delete products',
      link: '/admin/products',
      btnText: 'Manage Products'
    },
    {
      icon: '🧾',
      label: 'Orders',
      count: stats.orders,
      description: 'View and track customer orders',
      link: '/admin/orders',
      btnText: 'View Orders'
    },
    {
      icon: '🏷️',
      label: 'Discounts',
      count: stats.discounts,
      description: 'Create and manage promo codes',
      link: '/admin/discounts',
      btnText: 'Manage Discounts'
    },
    {
      icon: '👥',
      label: 'Users',
      count: stats.users,
      description: 'View accounts and manage admins',
      link: '/admin/users',
      btnText: 'Manage Users'
    }
  ];

  return (
    <div className="container py-5">
      <h4 className="fw-bold text-uppercase mb-1" style={{ letterSpacing: '0.08em' }}>Admin Dashboard</h4>
      <p className="text-muted small mb-4">Pork Co. store overview.</p>

      <div className="row g-4">
        {cards.map(card => (
          <div className="col-sm-6 col-lg-3" key={card.label}>
            <div className="card shadow-sm border-0 h-100 admin-card text-center">
              <div className="card-body p-4">
                <div className="display-4 mb-2">{card.icon}</div>
                <h5 className="fw-bold">{card.label}</h5>
                <p className="display-6 fw-bold text-pink mb-1">{card.count}</p>
                <p className="text-muted small mb-3">{card.description}</p>
                <Link to={card.link} className="btn btn-piggy btn-sm">
                  {card.btnText}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminDashboard;
